export const INCOME_TAX_INFINITE_AMOUNT = 9999999999999999999;
